import React from 'react';
import useContext from '../../../hooks/useContext';

import ProgressBar from '../../../styled/ProgressBar';
import Text from '../../../styled/Text';
import Distance from '../../../styled/Distance';

import { CategoryContext } from './Providers/CategoryProvider';

const ArticleCount = () => {
  const { disableLoadMore, totalHits, showCount } = useContext(CategoryContext);

  if (!totalHits || disableLoadMore) {
    return null;
  }

  return (
    <>
      <Text weight="medium" align="center">
        {`Visar ${showCount} av ${totalHits} produkter`}
      </Text>
      <Distance size={['1', '2']} />
      <ProgressBar progress={showCount / totalHits} small />
      <Distance size="3" />
    </>
  );
};

export default ArticleCount;
